
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1wzqe_1e3ff_99",
  "search-field": "awsui_search-field_1wzqe_1e3ff_134",
  "input-wrapper": "awsui_input-wrapper_1wzqe_1e3ff_140",
  "add-token": "awsui_add-token_1wzqe_1e3ff_144",
  "tokens": "awsui_tokens_1wzqe_1e3ff_151",
  "token-operator": "awsui_token-operator_1wzqe_1e3ff_156",
  "property-editor": "awsui_property-editor_1wzqe_1e3ff_160",
  "token-editor": "awsui_token-editor_1wzqe_1e3ff_161",
  "property-editor-form": "awsui_property-editor-form_1wzqe_1e3ff_166",
  "token-editor-form": "awsui_token-editor-form_1wzqe_1e3ff_167",
  "property-editor-field-property": "awsui_property-editor-field-property_1wzqe_1e3ff_170",
  "token-editor-field-property": "awsui_token-editor-field-property_1wzqe_1e3ff_171",
  "property-editor-field-operator": "awsui_property-editor-field-operator_1wzqe_1e3ff_174",
  "token-editor-field-operator": "awsui_token-editor-field-operator_1wzqe_1e3ff_175",
  "property-editor-field-value": "awsui_property-editor-field-value_1wzqe_1e3ff_178",
  "token-editor-field-value": "awsui_token-editor-field-value_1wzqe_1e3ff_179",
  "property-editor-cancel": "awsui_property-editor-cancel_1wzqe_1e3ff_182",
  "token-editor-cancel": "awsui_token-editor-cancel_1wzqe_1e3ff_183",
  "property-editor-submit": "awsui_property-editor-submit_1wzqe_1e3ff_186",
  "token-editor-submit": "awsui_token-editor-submit_1wzqe_1e3ff_187",
  "property-editor-actions": "awsui_property-editor-actions_1wzqe_1e3ff_190",
  "token-editor-actions": "awsui_token-editor-actions_1wzqe_1e3ff_191",
  "custom-content-wrapper": "awsui_custom-content-wrapper_1wzqe_1e3ff_209",
  "custom-control": "awsui_custom-control_1wzqe_1e3ff_213",
  "input": "awsui_input_1wzqe_1e3ff_140",
  "results": "awsui_results_1wzqe_1e3ff_221",
  "token-trigger": "awsui_token-trigger_1wzqe_1e3ff_226",
  "remove-all": "awsui_remove-all_1wzqe_1e3ff_231",
  "token-label": "awsui_token-label_1wzqe_1e3ff_232",
  "join-operation": "awsui_join-operation_1wzqe_1e3ff_233",
  "custom-filter-actions": "awsui_custom-filter-actions_1wzqe_1e3ff_234"
};
  